import { ViewFactory } from 'wdc-cube-react'
import { ChipPanelScope } from '../ChipPanel.scopes'
import { ChipPanelView } from './ChipPanel.view'

export function registerViews(rv = ViewFactory.register) {
    rv(ChipPanelScope, ChipPanelView)
}
